import { accessCookie } from './lib/cookie'

accessCookie('cicada')

$('.js-tel-cicada').tewrap({
  phoneNumber: '03-6434-1255'
})



// WEBPACK FOOTER //
// ./src/js/cicada.js